import React from 'react';
import { BodyMBold } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bwodHeaderStyle';
import { dynamicTranslate } from 'components/Translation';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IHeading {
	heading: string;
	imageURL: string;
	background: string;
}

export const BWODCardHeading = ({ heading, imageURL, background }: IHeading) => {
	const classes = useStyles({ background });

	return (
		<div className={classes.headingWrapper}>
			<BodyMBold customClassName={classes.heading}>{heading}</BodyMBold>
			<img src={imageURL} className={classes.discount} />
		</div>
	);
};
